import { Participant } from 'livekit-client';
import { ParticipantsCount } from 'features/Modals/ParticipantsModal';
import { SummaryPanel } from 'features/Summary';
import { StageProps } from '../types';
import { ControlsArea, ControlsAreaLeft, ControlsAreaRight, StageFooterContainer } from '../view';
import { ChangeMeetLayoutButton } from './ChangeStageButton/ChangeStageButton';
import { ControlsPanel } from './ControlsPanel/ControlsPanel';
import { ChatButton } from './ChatButton/ChatButton';
import { Badge } from './Badge/Badge';

type StageFooterProps = Pick<StageProps, 'roomState' | 'controlRenderer' | 'onLeave'> & {
    participants: Participant[];
    isInterfaceHidden?: boolean;
    registerAlwaysVisibleElement?: (ref: React.RefObject<HTMLElement | null>) => () => void;
};

export const StageFooter = ({
    roomState,
    controlRenderer,
    onLeave,
    participants,
    isInterfaceHidden,
    registerAlwaysVisibleElement,
}: StageFooterProps) => {
    const { room } = roomState;

    if (!room) {
        return null;
    }

    const ControlRenderer = controlRenderer ?? ControlsPanel;

    return (
        <StageFooterContainer>
            <ControlsArea>
                <ControlsAreaLeft>
                    <Badge />
                </ControlsAreaLeft>
                <ControlRenderer
                    room={room}
                    onLeave={onLeave}
                    isInterfaceHidden={isInterfaceHidden}
                    registerAlwaysVisibleElement={registerAlwaysVisibleElement}
                />
                <ControlsAreaRight>
                    <SummaryPanel />
                    <ChangeMeetLayoutButton />
                    <ChatButton />
                    <div>
                        <ParticipantsCount count={participants.length} />
                    </div>
                </ControlsAreaRight>
            </ControlsArea>
        </StageFooterContainer>
    );
};
